import { useContext } from 'react'
import { LoginContext } from '../components/context/loginContext'

/**
 * Accede al contexto de autenticación (LoginContext).
 *
 * Centraliza el consumo del contexto y valida que se use dentro de un
 * `LoginProvider`, evitando el `undefined` silencioso de `useContext` cuando
 * no hay provider en el árbol.
 *
 * @returns {object} El value del LoginContext (loginDataContext, esPerfilAdmin,
 *   token, isAuthenticated, cargandoUsuario, logout, renewToken, updateUserData,
 *   setLoginData).
 */
export const useAuth = () => {
  const context = useContext(LoginContext)
  if (context === undefined) {
    throw new Error('useAuth debe usarse dentro de un LoginProvider')
  }
  return context
}
